module.exports = __webpack_public_path__ + "img/Weapon_145.4676e7ec.png";